import omit from "lodash/omit";
import parseLinkHeader from "parse-link-header";

import bakery from "./bakery";

const encodeParams = params => {
  if (Object.keys(params).length === 0) {
    return "";
  }
  return `${Object.entries(params)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&")}`;
};

const encodeFilter = filter =>
  `&where=${encodeURIComponent(JSON.stringify(filter))}`;

// We manually wrap macaroon-bakery calls in promises here
// until the library supports returning promises.
/**
 *
 * @param {String} url
 * @param {Object} params - key=val url params
 * @param {Object} filter - A flask-potion filter expression/object
 */
export const get = (url, params = {}, filter) => {
  let urlWithParams = `${url}?${encodeParams(params)}`;
  if (filter) {
    urlWithParams += encodeFilter(filter);
  }
  return new Promise((resolve, reject) => {
    bakery.get(urlWithParams, [], (error, data) => {
      const links = parseLinkHeader(data.target.getResponseHeader("Link"));
      let response;
      if (data.target.response) {
        try {
          response = JSON.parse(data.target.response);
        } catch (error) {
          reject(Error(`Unable to parse response: ${error}`));
        }
      }
      if (data.target.status === 200) {
        resolve({
          response,
          links
        });
      } else {
        const msg = response ? response.message : "An error occurred";
        const error = new Error(
          `${msg}: (status: ${data.target.status}, url: ${url})`
        );
        error.status = data.target.status;
        reject(error);
      }
    });
  });
};

/**
 * Remove internal properties from state objects.
 * @param {object} data
 */
const cleanData = data =>
  omit(data, ["$uri", "id", "requiresDelete", "requiresUpdate"]);

/**
 * Handle posts using bakery.
 * @param {String} url A url to post to.
 * @param {*} data The data to post (will become JSON).
 * @param {Object} headers A set of headers to be included in the post request.
 * @param {Array} getHeaders A list of header keys to return from the response.
 * @returns {Promise} A promise to handle the post request.
 */
export const post = (url, data, headers = {}, getHeaders) => {
  const json = JSON.stringify(cleanData(data));
  return new Promise((resolve, reject) => {
    bakery.post(
      url,
      { "Content-Type": "application/json", ...headers },
      json,
      (error, data) => {
        let returnedHeaders;
        if (getHeaders) {
          returnedHeaders = {};
          getHeaders.forEach(header => {
            returnedHeaders[header] = data.target.getResponseHeader(header);
          });
        }
        let response;
        if (data.target.response) {
          try {
            response = JSON.parse(data.target.response);
          } catch (error) {
            reject(Error(`Unable to parse response: ${error}`));
          }
        }
        if (data.target.status === 200) {
          const returned = { response };
          if (returnedHeaders) {
            returned.headers = returnedHeaders;
          }
          resolve(returned);
        } else {
          const msg = response ? response.message : "An error occurred";
          const error = Error();
          error.message = `${msg}: (status: ${
            data.target.status
          }, url: ${url})`;
          error.code = data.target.status;
          reject(error);
        }
      }
    );
  });
};

export const del = url =>
  new Promise((resolve, reject) => {
    bakery.delete(url, {}, {}, (error, data) => {
      const { status } = data.target;
      if (status === 204) {
        resolve(true);
      } else {
        reject(Error(`status: ${status}, url: ${url}`));
      }
    });
  });
